import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  WebReserveResource,
  CustomerIntroducerRequestResource,
} from '@blcloud/bl-ng-resource';
import { WebReserveDetailComponent } from './web-reserve-detail.component';
import { WebReserveDetailService } from './web-reserve-detail.service';

/**
 * Web予約詳細モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    TooltipModule
  ],
  declarations: [
    WebReserveDetailComponent
  ],
  entryComponents: [
    WebReserveDetailComponent
  ],
})
export class WebReserveDetailModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WebReserveDetailModule,
      providers: [
        WebReserveResource,
        WebReserveDetailService,
        CustomerIntroducerRequestResource,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-detail/web-reserve-detail.module.ts